import { RefabricProURL } from "../index";
import { ApiResponse } from "../HttpClient";
import {
  ICreditMultiplierResponse,
  IGuestStartRequest,
  IGuestStartResponse,
  IGuestVerifyRequest,
  IGuestVerifyResponse,
  IPaymentActionItem,
  IPaymentAddonStartItem,
  IPaymentAddonsResponse,
  ISeatChangeRequest,
  IStartPayment,
} from "./payment.type";

export default {
  async getPackageList(): Promise<ApiResponse<any>> {
    return await RefabricProURL.get(`/payments/package_list`, {});
  },
  async getAddons(): Promise<ApiResponse<IPaymentAddonsResponse>> {
    return await RefabricProURL.get(`/payments/addons`, {});
  },
  async startAddonCheckout(price_id: string): Promise<ApiResponse<IPaymentAddonStartItem[]>> {
    return await RefabricProURL.get(`/payments/addons/start/${encodeURIComponent(price_id)}`, {});
  },
  // `signal`: the checkout in-flight guard aborts a stalled start (hooks/useCheckoutInFlight).
  async startPayment({ product_id, price_id, seat }: IStartPayment, config?: { signal?: AbortSignal }): Promise<ApiResponse<IPaymentActionItem[]>> {
    return await RefabricProURL.get(`/payments/start/${product_id}/${price_id}`, { params: { seat: seat }, signal: config?.signal });
  },
  async guestStart(payload: IGuestStartRequest): Promise<ApiResponse<IGuestStartResponse>> {
    return await RefabricProURL.post(`/payments/guest/start`, payload);
  },
  // REF-5421: read-only classification of a completed guest checkout for the
  // success page. Routes on responseData.action (pending|existing_active|purchased|error).
  async guestVerify(payload: IGuestVerifyRequest): Promise<ApiResponse<IGuestVerifyResponse>> {
    return await RefabricProURL.post(`/payments/guest/verify`, payload);
  },
  // REF-5549 (BE REF-5446): admin seat add/remove. Returns HTTP 200 + action list (see IPaymentActionItem).
  async changeSeats(data: ISeatChangeRequest, config?: { signal?: AbortSignal }): Promise<ApiResponse<IPaymentActionItem[]>> {
    return await RefabricProURL.post("/payments/seats", data, { signal: config?.signal });
  },
  async managePortal(): Promise<ApiResponse<any>> {
    return await RefabricProURL.get("/payments/manage_portal", {});
  },
  async getPackageListPhotoshoot(): Promise<ApiResponse<any>> {
    return await RefabricProURL.get(`/payments/package_list_photoshoot`, {});
  },
  async getCreditMultiplier(): Promise<ApiResponse<ICreditMultiplierResponse>> {
    return await RefabricProURL.get(`/payments/credit-multiplier`, {});
  },

  async endTrial(): Promise<ApiResponse<any>> {
    return await RefabricProURL.post("/payments/end-trial", {});
  },
};
